module.exports = "/images/Correios_v2.png?4fcc4e87bc4b09c53a6cd370ded1767e";